<div class="name">{{user?.name}}</div>
<table class="default">
  <tr><td class="caption">Отдел</td><td class="value">{{department?.title || '—'}}</td></tr>
  <tr><td class="caption">Должность</td><td class="value">{{member.position || '—'}}</td></tr>
  <tr><td class="caption">Внутренний телефон</td><td class="value">{{member.intercom || '—'}}</td></tr>
  <tr><td class="caption">Кабинет</td><td class="value">{{member.room || '—'}}</td></tr>
</table>
